import { FC } from "react";
import { ExplainerTrigger } from "../atoms";
import { ExplainerContent } from "../organisms";
import { useAtomValue } from "jotai";
import { explainerContentQuestionAtom } from "../../jotai-atoms";
import * as Dialog from "../ui/dialog";
import { getExplainerExpression } from "../../utils";

interface ExplainerDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const ExplainerDialog: FC<ExplainerDialogProps> = ({
  open,
  setOpen,
}) => {
  const explainerExpression = useAtomValue(explainerContentQuestionAtom);

  if (!explainerExpression) return null;

  const data = {
    title: explainerExpression?.title,
    ...getExplainerExpression(explainerExpression?.expression),
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild id="explainer-dialog-trigger">
        <ExplainerTrigger />
      </Dialog.Trigger>
      <Dialog.Content>
        <ExplainerContent data={data} />
      </Dialog.Content>
    </Dialog.Root>
  );
};
